define(function (require, exports, module) {
    'use strict';

    var BackendResponseData = require('./BackendResponseData');
    var UploadReason = require('../../UploadReason');
    var MalformedError = require('../../errors/MalformedError');

    /**
     * @namespace
     */
    var backendResponseTextOfPut = {
        /**
         * Matches response text like:
         * "EC349C1F081BB8A80C682FD69098093CAF6C8726"
         * @type {RegExp}
         */
        hashPattern: /^[0-9ABCDEF]{40}$/,

        /**
         * Parse response text like:
         * "EC349C1F081BB8A80C682FD69098093CAF6C8726"
         * @param {string} responseText
         * @returns {BackendResponseData}
         */
        parse: function (responseText) {
            var isHash = backendResponseTextOfPut.hashPattern.test(responseText);
            var hash;
            var size;
            var error;

            if (isHash) {
                hash = responseText;
            } else {
                var source = UploadReason.SOURCE_BACKEND;
                var stack = new Error('MalformedError');

                error = new MalformedError(stack, source, responseText);
            }

            var data = new BackendResponseData(hash, size, error);

            return data;
        },
    };

    module.exports = backendResponseTextOfPut;
});
